let paymentTypes = [
  { value: "DIGITAL_PAYMENT", label: "JULAYA" },
  { value: "BANK_TRANSFER", label: "VIREMENT" },
  { value: "CASH", label: "ESPECE" },
];

export default paymentTypes;
